import { useEffect, useRef } from 'react';

/**
 * Subscribe to a Server-Sent Events stream. Reconnects automatically (EventSource does this on its
 * own; we also reopen after the tab comes back to the foreground).
 */
export function useEventSource(url: string | null, handlers: Record<string, (data: unknown) => void>) {
  const ref = useRef(handlers);
  ref.current = handlers;
  useEffect(() => {
    if (!url || typeof EventSource === 'undefined') return;
    let es: EventSource | null = null;
    const events = Object.keys(ref.current);
    const open = () => {
      es?.close();
      es = new EventSource(url, { withCredentials: true });
      for (const ev of events) {
        es.addEventListener(ev, (e) => {
          let data: unknown = null;
          try {
            data = JSON.parse((e as MessageEvent).data);
          } catch {
            /* ignore */
          }
          ref.current[ev]?.(data);
        });
      }
    };
    open();
    const onVis = () => {
      if (document.visibilityState === 'visible' && es?.readyState === EventSource.CLOSED) open();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      document.removeEventListener('visibilitychange', onVis);
      es?.close();
    };
  }, [url]);
}
